<template>
    <div>
        <div class="image">
            <img v-if="item.image" :src="item.image.public_path" class="img-fluid" :alt="item.image.alt"/>
        </div>

        <div class="body">
            <h4>{{ item.title }}</h4>
            <div v-html="item.blurb"></div>

            <a class="btn btn-danger d-flex flex-nowrap align-items-center" :href="`blog/${item.slug}`"><span class="pe-3">{{btnText}}</span> <img src="https://asurcloudrunprod-16905.kxcdn.com/public-assets/right-arrow-icon" alt="arrow" class="arrow-icon"></a>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        item: Object,
        locale: String
    },
    computed: {
        btnText() {
            return this.locale == 'es' ? 'Conocer más' : 'Learn more';
        }
    }
}
</script>